module.exports = __webpack_public_path__ + "static/img/institution02.47ee0b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/institution02.png
// module id = kZiz
// module chunks = 1